module.exports = __webpack_public_path__ + "static/img/biankuang22.0d23bd8.png";


//////////////////
// WEBPACK FOOTER
// ./static/biankuang22.png
// module id = a19B
// module chunks = 1